//eslint-disable-next-line
import { appInfo } from "@/common/data/appinfo";
import sidedata from "./sidedata";
import beceRoutes from "./beceRoutes";
import school from "./school";
import dashboard from "./dashboard";
import payments from "./payments";
import auth from "./auth";
import baiceRoutes from "./baiceRoutes";
import saiqeRoutes from "./saiqeRoutes";
import qeRoutes from "./qeRoutes";
export default [
  ...auth,
  ...sidedata,
  ...beceRoutes,
  ...saiqeRoutes,
  ...baiceRoutes,
  ...qeRoutes,
  ...school,
  ...dashboard,
  ...payments,
  {
    path: "/",
    name: "home",
    component: () => import("@/views/auth/index.vue"),
    meta: {
      title: "HOME",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/auth/login.vue"),
    meta: {
      title: "Login",
    },
  },

  {
    path: "/Zuzren/:params?",
    name: "g_institution_report",
    meta: {
      title: appInfo?.type == "codsm" ? "Institution Report" : "School Report",
      authRequired: false,
    },
    component: () => import("@/views/auth/report.vue"),
  },
  {
    path: "/XmyeVqbZfhIdxAqw78QX/:menu",
    name: "menu",
    meta: {
      title: "Menu List",
      authRequired: true,
      // acc: "admin",
    },
    component: () => import("@/components/menu-list.vue"),
  },
  {
    path: "/ngihfnefywu09nrr8wrr",
    name: "appInfo",
    meta: {
      title: "Update Application Information",
      authRequired: true,
    },
    component: () => import("@/views/settings/appInfo/new.vue"),
  },
  {
    path: "/privacy",
    name: "privacyPolicies",
    meta: {
      title: "Privacy and policies",
      authRequired: false,
    },
    component: () => import("@/views/auth/privacyPolicies.vue"),
  },

  {
    path: "/notfound",
    name: "notfound",
    meta: {
      title: "404",
      //
    },
    component: () => import("@/views/notfound/404-cover"),
  },
  // start of import
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    meta: {
      title: "404",
      //
    },
    component: () => import("@/views/notfound/404-cover"),
  },
  // end of import
];
